import { lazy } from 'react';
import { useParams } from 'react-router';
import { useAllocation } from 'src/apis/reshuffle-service/use-allocation';
import { useEligibleExistingContractedCapacities } from 'src/apis/reshuffle-service/use-eligible-existing-contracted-capacities';
import { useReshuffleServiceRoot } from 'src/apis/reshuffle-service/use-reshuffle-service';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { PageSpinner } from 'src/components/spinner-container';
import { isVerificationProblemWithoutField } from 'src/utils/is-verification-problem-without-field';

const Page = lazy(() => import('./page'));

export const CreateReshuffleRequest = () => {
  const { allocationId } = useParams<{ allocationId?: string }>();

  const reshuffleServiceRoot = useReshuffleServiceRoot();
  const allocationDetails = useAllocation({
    reshuffleServiceRoot,
    allocationId,
  });

  const eligibleExistingContractedCapacities =
    useEligibleExistingContractedCapacities({
      allocationDetails,
    });

  const eligibleExistingContractedCapacitiesUrl =
    allocationDetails.response?.data._links
      .getEligibleExistingContractedCapacities?.href;

  const eligibleError = eligibleExistingContractedCapacities.error;
  const notEligibleMessage = isVerificationProblemWithoutField(eligibleError)
    ? eligibleError.response.data.message
    : undefined;

  if (
    !reshuffleServiceRoot.response ||
    !allocationDetails.response ||
    (eligibleExistingContractedCapacitiesUrl &&
      !eligibleExistingContractedCapacities.loaded)
  )
    return <PageSpinner />;

  if (!allocationId) {
    return <ThrowNotFound />;
  }

  return (
    <Page
      newAllocationDetails={allocationDetails.response.data}
      eligibleExistingContractedCapacities={
        eligibleExistingContractedCapacities.response?.data._embedded.items ??
        []
      }
      notEligibleMessage={notEligibleMessage}
    />
  );
};
